import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserFriendlyError } from '../../../model/Error'
import { resourceHistoryKeys } from './resourceHistory.keys'
import { ResourceHistoryMutationPayload } from '../../../data/resourceHistory/mapper'
import { createResourceHistory } from '../../../data/resourceHistory/createResourceHistory'

export const useCreateResourceHistory = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: ResourceHistoryMutationPayload) => {
      const { data, ok } = await createResourceHistory(payload)
      if (!data || !ok) {
        throw new UserFriendlyError('error', `La création de l'historique a échoué`)
      }
      return data
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: resourceHistoryKeys.lists })
      queryClient.invalidateQueries({ queryKey: resourceHistoryKeys.all })
    },
  })
}
